import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { capturePageview } from './analytics';

const PostHogTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const captureTimer = window.setTimeout(() => {
      capturePageview(location.pathname);
    }, 0);

    return () => window.clearTimeout(captureTimer);
  }, [location.pathname]);

  return null;
};

export default PostHogTracker;
